// export const server_address = 'http://127.0.0.1:8000/';

export const server_address='https://gst-server-zy5h.onrender.com/';